import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import firebase from '../../Firebase';
import './ChatSliderWidget.css';

// A box for the member's town or city, put in the chat by the community bot
// when their profile doesn't say where they're based, or they want to change
// it. Sent as a bot message whose text is LOCATION_WIDGET_PREFIX + {}; the
// prefix must match backend/controllers/Functions/communityChatBot.js. Saves
// only their area and map position (communiUser/myLocation, setMyLocation).
export const LOCATION_WIDGET_PREFIX = '__LOCATION_WIDGET__';

const call = async (path, body) => {
  const token = await firebase.auth().currentUser?.getIdToken();
  const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/communiUser/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, 'X-CSRF-Token': Cookies.get('mytoken') },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
};

const ChatLocationWidget = () => {
  const [current, setCurrent] = useState(null);
  const [place, setPlace] = useState('');
  const [state, setState] = useState('ready'); // ready | saving | saved | error
  const [error, setError] = useState('');

  useEffect(() => {
    let live = true;
    call('myLocation', {}).then((d) => live && setCurrent(d.localArea || '')).catch(() => live && setCurrent(''));
    return () => { live = false; };
  }, []);

  const save = async (e) => {
    e.preventDefault();
    if (!place.trim() || state === 'saving') return;
    setState('saving');
    setError('');
    try {
      const d = await call('setMyLocation', { place });
      setCurrent(d.localArea);
      setPlace('');
      setState('saved');
    } catch (err) {
      setError(err.message);
      setState('error');
    }
  };

  return (
    <form className="chatSlider chatLocation" onSubmit={save}>
      <div className="chatSlider-head">
        <span>Where you&apos;re based</span>
        {current ? <strong>{current}</strong> : null}
      </div>
      <div className="chatLocation-row">
        <input
          type="text"
          value={place}
          onChange={(e) => { setPlace(e.target.value); if (state !== 'saving') setState('ready'); }}
          placeholder={current ? 'New town or city' : 'Your town or city, e.g. Leicester'}
          aria-label="Your town or city"
          maxLength={120}
        />
        <button type="submit" disabled={!place.trim() || state === 'saving'}>{state === 'saving' ? 'Saving…' : 'Save'}</button>
      </div>
      <div className="chatSlider-status" aria-live="polite">
        {state === 'saved' ? `Saved ✓ — ${current}`
          : state === 'error' ? error
            : 'Saved to your profile, to find people near you'}
      </div>
    </form>
  );
};

export default ChatLocationWidget;
